import React, { useState, useEffect, useRef } from "react";
import MathJax from '../component/react-mathjax-preview';
import { NavigationDrawer, DialogContainer } from 'react-md';
import TextEditor from '../component/TextEditor';
import { Swiper, Slide } from 'react-dynamic-swiper'
import { stateToHTML } from 'draft-js-export-html';
import { convertFromRaw, convertToRaw, EditorState } from 'draft-js';
import '../css/custom.css';
import 'react-dynamic-swiper/lib/styles.css'
import { Button, Tooltip } from '@mui/material'
import { HiOutlineZoomIn, HiOutlineZoomOut } from "react-icons/hi";

let options = {
    // blockRenderers: {
    //   unstyled: (block) => {
    //     let data = block.getData();

    //     let blockText = block.getText();
    //     if(blockText.trim() === '') //bug-tracker#264
    //       return '';
    //     let style = '';
    //     if( data.includes('ALIGN_CENTER'))
    //       style = "style='text-align:center;'"
    //     if(data.includes('ALIGN_RIGHT'))
    //       style = "style='text-align:right;'"
    //     if(data.includes('ALIGN_LEFT'))
    //       style = "style='text-align:left;'"
    //     return '<p '+style+'>' + blockText + '</p>'
    //   },
    // }, 
    blockStyleFn: (block) => {
        let data = block.getData();
        if (data.size == 0) return;

        let style = {};
        if (data.get('text-align')) style = { ...style, textAlign: data.get('text-align') }
        return {
            attributes: {
                dir: 'auto'
            },
            style
        };
    },
    entityStyleFn: (entity) => {
        const entityType = entity.get('type').toLowerCase();
        //console.log("entityType",entityType);

        if (entityType === 'image') {
            const data = entity.getData();
            ////console.log('image-data',data);
            let computedWidth = data.width;
            if (computedWidth === undefined)
                computedWidth = 30;
            return {
                element: 'img',
                attributes: {
                    src: data.src,
                },
                style: {
                    width: computedWidth + '%'
                },
            };
        }
        if (entityType === 'draft-js-video-plugin-video') {
            const data = entity.getData();
            ////console.log('image-data',data);
            let computedWidth = data.width;
            if (computedWidth === undefined)
                computedWidth = 30;
            return {
                element: 'iframe',
                attributes: {
                    src: data.src,
                    width: 420,
                    height: 315,
                    allowfullscreen: '',
                }
            };
        }
    },
};

const defaultImageWidth = 350;

const ExplanationPreview = (props) => {

    const explanationRef = useRef(null);
    const [navItems, setNavItems] = useState([]);
    const [index, setIndex] = useState(props.selectedRowIndex);
    const [imageWidthArr, setImageWidthArr] = useState([]);
    const [showZoomButton, setShowZoomButton] = useState(false);


    useEffect(() => {
        moveToSlide(props.selectedRowIndex);
    }, [props.selectedRowIndex])

    useEffect(() => {
        if (props.explanations && props.explanations.length) {
            let updatedWidthArr = [];
            props.explanations.forEach((expl, index) => {
                let obj = {
                    id: `${expl.subject_id}_${expl.topic_id}_${expl.category_id}_${expl.topic_id}_${index}`,
                    width: defaultImageWidth,
                }
                updatedWidthArr.push(obj);
            })

            setImageWidthArr(updatedWidthArr);
        }
    }, []);

    useEffect(() => {
        if (props.visible && props.explanations && props.explanations.length) {
            let newItems = [];
            props.explanations.forEach((exp, i) => {
                newItems.push({
                    active: i === index,
                    primaryText: exp.explanation_name,
                    style: i === index ? { backgroundColor: '#dadbdc', color: '#ba0c2f' } : {},
                    onClick: () => moveToSlide(i)
                })
            });

            let activeExplanation = props.explanations[index];
            if (activeExplanation.text !== undefined && activeExplanation.text !== null && activeExplanation.text.trim() !== "") {
                let text = convertToHTML(activeExplanation);
                setShowZoomButton(checkIfTextContainsAnImage(text));
            }

            setNavItems(newItems);
        }
    }, [index]);

    const moveToSlide = (i) => {
        // setIndex(i);
        var mySwiper2 = document.querySelector('.swiper-container').swiper
        mySwiper2.slideTo(i, 1500);
    }

    const convertToHTML = (exp) => {
        let retVal = "";
        try {
            if (exp.text === null || exp.text === undefined || exp.text === "") return retVal;
            const contentState = convertFromRaw(JSON.parse(exp.text));
            const editorState = EditorState.createWithContent(contentState);

            retVal = stateToHTML(editorState.getCurrentContent(), options);


            if (exp.alt_explanation_text !== undefined && exp.alt_explanation_text !== null && exp.alt_explanation_text !== "") {
                //alt feedback text
                var tempDisplayExplanationText = retVal
                var altExplanationText = exp.alt_explanation_text
                altExplanationText = altExplanationText.replace(/\n/ig, ' ')
                //finding number of time image present
                var altExplanationTextCount = altExplanationText.split(';').length
                var ExplanationImgTagCount = tempDisplayExplanationText.split('<img').length - 1
                console.debug((altExplanationTextCount / 2), "==", ExplanationImgTagCount)
                if ((altExplanationTextCount / 2) == ExplanationImgTagCount) {
                    if (ExplanationImgTagCount >= 1) {
                        console.debug("Answer greater than 1")
                        var altExplanationTextArr = altExplanationText.split(';');
                        var lastPosOfImg = 0
                        // console.debug("altanswer",altExplanationTextArr)
                        for (var j = 0; j <= altExplanationTextArr.length - 1; j = j + 2) {
                            // console.debug(j)
                            lastPosOfImg = tempDisplayExplanationText.indexOf("<img", lastPosOfImg)
                            lastPosOfImg = lastPosOfImg + 4
                            var b = "  title =\"" + altExplanationTextArr[j] + "\"  alt =\"" + altExplanationTextArr[j + 1] + "\" "
                            var output = [tempDisplayExplanationText.slice(0, lastPosOfImg), b, tempDisplayExplanationText.slice(lastPosOfImg)].join('');
                            tempDisplayExplanationText = output
                            // console.debug("answertest", j, " ", tempDisplayExplanationText)
                        }
                    }
                }
                retVal = tempDisplayExplanationText
            }

        }
        catch (err) {
            console.error(err.message);
        }
        return retVal;
    }

    const handleQuestionResize = (type) => {
        if (explanationRef && explanationRef.current) {

            let obj = imageWidthArr[index];
            let doc = document.getElementById(`expl-${index}`);
            let images = doc.querySelectorAll('img');
            if (images && images.length) {
                obj.width = type === "plus" ? obj.width + 100 : obj.width - 100;
                images.forEach(img => {
                    img.style.setProperty('width', `${obj.width}px`, 'important');
                });
                let updatedImageWidthArr = imageWidthArr;
                updatedImageWidthArr[index] = obj;
                setImageWidthArr(updatedImageWidthArr);
            }
        }
    }


    const checkIfTextContainsAnImage = (text) => {
        if (text === undefined || text === null || text === "") return false;
        return text.includes("<img") && text.includes("</img>")
    }


    return (
        <DialogContainer
            visible={props.visible}
            width={'100%'}
            fullPage={window.innerWidth < 768}
            height={window.innerWidth < 768 ? '100%' : '80%'}
            className='explanation-dialog'
            focusOnMount={false}>

            {showZoomButton ?
                <div className='sf-image-resize-btn-div'>
                    <Tooltip placement="top" arrow title="Magnify all images within this explanation">
                        <div className="sf-image-resize-btn"
                            style={{
                                fontSize: "3rem !important"
                            }}
                            onClick={() => {
                                handleQuestionResize("plus")
                            }}>

                            <HiOutlineZoomIn fontSize={25} />
                        </div>
                    </Tooltip>
                    <Tooltip placement="top" arrow title="Shrink all images within this explanation">
                        <div className="sf-image-resize-btn"
                            onClick={() => {
                                handleQuestionResize("minus")
                            }}
                        >

                            <HiOutlineZoomOut fontSize={25} />
                        </div>
                    </Tooltip>
                </div>
                : null}


            <NavigationDrawer
                drawerHeader={<div style={{ padding: "20px", background: '#ba0c2f' }}><h2 style={{ color: '#fff' }}>Explanations</h2></div>}
                navItems={navItems}
                desktopDrawerType={NavigationDrawer.DrawerTypes.FULL_HEIGHT}
                includeDrawerHeader={true}

            >
                <div ref={explanationRef} >
                    <Swiper
                        navigation={true}
                        pagination={false}

                    >
                        {
                            props.explanations?.map((exp, i) => {
                                let text = "";
                                if (exp.text !== undefined && exp.text !== null && exp.text.trim() !== "") {
                                    text = convertToHTML(exp);
                                }

                                return (
                                    <Slide key={i}
                                        onActive={swiper => {
                                            if (swiper) {
                                                setIndex(swiper.realIndex)
                                            }
                                        }}
                                    >
                                        <div style={{
                                            width: 'calc(100% - 256px)',
                                            height: "100%",
                                            overflowY: 'auto',
                                        }}>

                                            <div
                                                id={`expl-${i}`}
                                                style={{
                                                    width: '95%',
                                                    position: 'relative',
                                                    height: "500px",
                                                    overflowY: 'auto',
                                                }}

                                            >
                                                <center className='explanation-div'>
                                                    <h2>{exp?.explanation_name}</h2>
                                                </center>
                                                {exp.text !== undefined && exp.text !== null && exp.text.trim() !== "" ?
                                                    <MathJax style={{ textAlign: "left", }} math={text} />
                                                    : null}
                                            </div>

                                        </div>
                                    </Slide>
                                )
                            }

                            )}
                    </Swiper>
                </div>
            </NavigationDrawer>
            <div style={{
                position: 'fixed',
                bottom: "6px",
                left: 0,
                width: '100%',
                zIndex: 99,
            }}>

                <center>
                    <Button variant='contained'
                        style={{
                            background: '#ba0c2f'
                        }}
                        size='small' onClick={() => {
                            props.closeLivePreview();
                        }}>
                        Close
                    </Button>
                </center>

            </div>
        </DialogContainer>
    );
}

export default ExplanationPreview;


/*   componentDidUpdate(prevProps, prevState) {
    if (this.state.navItemsArray && this.state.navItemsArray.length === 0) {
      if(this.state.explanations && this.state.explanations.length) {
        let navItemsArray = [];
        for (let i = 0; i < this.state.explanations.length; i++) {
          navItemsArray.push({
            primaryText: this.state.explanations[i].explanation_name,
            onClick: () => this.moveToSlide(i)
          });
        }
        this.setState({
          navItemsArray: navItemsArray,
        })
      }
    }
    var mySwiper2 = document.querySelector('.swiper-container')
    if (this.state.explanations) {
      console.debug("mySwiper2>>??", mySwiper2)
    }
    
  } */